module.exports = __webpack_public_path__ + "static/BrandonGrotesque-Bold-3e4f70593ab53102482e624f2ed91c43.woff";